import { styled } from "@mui/material/styles";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Button } from "@mui/material";
const OrderLabelMain = styled("div")(({ theme }) => ({
  margin: "0 auto",
  marginTop: "25px",
  marginBottom: "50px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    marginTop: "0px",
  },
  [theme.breakpoints.up("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "80%",
  },
}));
const OrderBox = styled("div")(({ theme }) => ({
  margin: "0 auto",
  marginTop: "25px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "90%",
  },
  border: "1px solid #000000",
  borderRadius: "11px",
  padding: "20px",
}));
const OrderImage = styled("div")(({ theme }) => ({
  textAlign: "center",
  paddingTop: "20px",
}));
const OrderLink = styled("div")(({ theme }) => ({
  background: "#0B0B0B",
  borderRadius: "19px",
  height: "1px",
  margin: "20px 0",
}));
const OrderFrom = styled("div")(({ theme }) => ({
  marginBottom: "15px",
  "& h6": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "13px",
    lineHeight: "13px",
    textTransform: "uppercase",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& span": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "14px",
    color: "rgba(11, 11, 11, 0.6)",
    fontFamily: theme.typography.fontFamily,
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "14px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
}));
const OrderTo = styled("div")(({ theme }) => ({
  marginBottom: "15px",
  "& h6": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "13px",
    lineHeight: "13px",
    textTransform: "uppercase",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& span": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "14px",
    color: "rgba(11, 11, 11, 0.6)",
    fontFamily: theme.typography.fontFamily,
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "14px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
}));
const Notes = styled("div")(({ theme }) => ({
  "& h6": {
    marginBottom: "5px",
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "13px",
    lineHeight: "13px",
    textTransform: "uppercase",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& p": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "13.9516px",
    lineHeight: "130%",
    color: "rgba(11, 11, 11, 0.6)",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
}));

const CustomerSec = styled("div")(({ theme }) => ({
  "& h6": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "13px",
    lineHeight: "13px",
    textTransform: "uppercase",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    marginBottom: "10px",
  },
  "& .boxsec": {
    background: "#FFFFFF",
    border: "1px solid #D1D1D1",
    boxShadow: "0px 0px 3.98616px rgba(0, 0, 0, 0.05)",
    borderRadius: "11px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 15px",
    marginBottom: "15px",
    "& h6": { textTransform: "capitalize" },
  },
  "& .signature_image": {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "70px",
    height: "70px",
  },
}));

const ButtomMain = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  flexDirection: "column",
}));
const PDFButtomMain = styled(PDFDownloadLink)(({ theme }) => ({
  background: "#F74242",
  borderRadius: "10px",
  marginBottom: "14px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "80%",
  },
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "15px",
  lineHeight: "25px",
  textAlign: "center",
  color: "#FFFFFF",
  textTransform: "inherit",
  padding: "12px 0px",
  textDecoration: "none",
  ":hover": { background: "#F74242" },
}));
const PDFButtom = styled(Button)(({ theme }) => ({
  background: "#F74242",
  borderRadius: "10px",
  marginBottom: "14px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
  [theme.breakpoints.up("md")]: {
    width: "100%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "80%",
  },
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "15px",
  lineHeight: "25px",
  textAlign: "center",
  color: "#FFFFFF",
  textTransform: "inherit",
  padding: "12px 0px",
  ":hover": { background: "#F74242" },
  "&.docx": { background: "#3B86F8" },
}));

export {
  OrderLabelMain,
  OrderBox,
  OrderImage,
  OrderLink,
  OrderFrom,
  OrderTo,
  Notes,
  CustomerSec,
  ButtomMain,
  PDFButtomMain,
  PDFButtom,
};
